import { adminServerInstance } from "../axios/instances";
import { ErrorTypes } from "../constants/general";
import NetworkError from '../models/error';
import {
    GET_STAFF_LIST,
    GET_STAFF_LIST_SUCCESS,
    GET_STAFF_LIST_FAIL,
    GET_BATCH, GET_BATCH_SUCCESS,
    GET_BATCH_FAIL,
    GET_BATCH_ORDER,
    GET_BATCH_ORDER_SUCCESS,
    GET_BATCH_ORDER_FAIL,
    CREATE_SUB_BATCH,
    CREATE_SUB_BATCH_FAIL,
    CREATE_SUB_BATCH_SUCCESS,
    GET_DIRECTION,
    GET_DIRECTION_SUCCESS,
    GET_DIRECTION_FAIL,
    GET_DISTRICT,
    GET_DISTRICT_SUCCESS,
    GET_DISTRICT_FAIL,
    ASSIGN_ORDER,
    ASSIGN_ORDER_SUCCESS,
    ASSIGN_ORDER_FAIL,
    GET_DRIVER_ORDER_COUNT,
    GET_DRIVER_ORDER_COUNT_FAIL,
    GET_DRIVER_ORDER_COUNT_SUCCESS,
    GET_DRIVER_ORDERS,
    GET_DRIVER_ORDERS_SUCCESS,
    GET_DRIVER_ORDERS_FAIL,
    RESET_ORDERS,
    GET_DISPATCH_HISTORY_LIST,
    GET_DISPATCH_HISTORY_LIST_SUCCESS,
    GET_DISPATCH_HISTORY_LIST_FAIL,
    CREATE_DISPATCH_HISTORY,
    CREATE_DISPATCH_HISTORY_SUCCESS,
    CREATE_DISPATCH_HISTORY_FAIL,
    GET_BATCH_INFO,
    GET_BATCH_INFO_SUCCESS,
    GET_BATCH_INFO_FAIL,
    UPDATE_DISPATCH_HISTORY,
    UPDATE_DISPATCH_HISTORY_SUCCESS,
    UPDATE_DISPATCH_HISTORY_FAIL,
    GET_ORDERS_STATUS_WEIGHT,
    GET_ORDERS_STATUS_WEIGHT_SUCCESS,
    GET_ORDERS_STATUS_WEIGHT_FAIL,
    GET_ZIPCODE_PATTERN,
    GET_ZIPCODE_PATTERN_SUCCESS,
    GET_ZIPCODE_PATTERN_FAIL,
    HANDLE_FILTER_CHANGE,
    GET_ORDERS_BY_SHIPPING_STATUS,
    GET_ORDERS_BY_SHIPPING_STATUS_SUCCESS,
    GET_ORDERS_BY_SHIPPING_STATUS_FAIL,
    GET_PARTNERS,
    GET_PARTNERS_SUCCESS,
    GET_PARTNERS_FAIL,
    LOCATION_VERIFY,
    LOCATION_VERIFY_SUCCESS,
    LOCATION_VERIFY_FAIL,
    HANDLE_CURRENT_DRIVER_ID,
    REVERT_ORDER_PATH_STATE_SUCCESS,
    UPDATE_ROUTE_PATTERN,
    UPDATE_ROUTE_PATTERN_SUCCESS,
    UPDATE_ROUTE_PATTERN_FAIL,
    GET_ZIP_CODE_BOUNDARY,
    GET_ZIP_CODE_BOUNDARY_SUCCESS,
    GET_ZIP_CODE_BOUNDARY_FAIL,
    GET_EXPIRATION_TYPE,
    GET_EXPIRATION_TYPE_SUCCESS,
    GET_EXPIRATION_TYPE_FAIL,
    UPDATE_EXPIRATION_TYPE,
    UPDATE_EXPIRATION_TYPE_SUCCESS,
    UPDATE_EXPIRATION_TYPE_FAIL,
    GET_WAREHOUSE_PATTERN,
    GET_WAREHOUSE_PATTERN_SUCCESS,
    GET_WAREHOUSE_PATTERN_FAIL
} from "./types";

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.route_no - Route number
 * @param {string} params.warehouse - Warehouse
 */
export function getZipCodeBoundary(params){
    return function (dispatch){
        dispatch({type: GET_ZIP_CODE_BOUNDARY})
        return adminServerInstance.get(`/map/getzipcodeboundary`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_ZIP_CODE_BOUNDARY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ZIP_CODE_BOUNDARY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function handleCurrentDriverId(driverId) {
    return function(dispatch){
    dispatch({type: HANDLE_CURRENT_DRIVER_ID})
    return (
        dispatch({
            type: HANDLE_CURRENT_DRIVER_ID,
            payload: driverId
        })
    )}
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.order_list - Order list
 * @param {string} params.batch_list - Batch list
 * @param {string} params.driver_id - Driver ID
 * @param {number} params.hide_associated - 1
 * @param {number} params.hide_sub_referrer - 0
 * @param {number} params.branch - Branch ID
 */
export function locationVerify(params){
    return function (dispatch){
        dispatch({type: LOCATION_VERIFY})
        return adminServerInstance.post(`/business/locationverify`, params)
        .then(({data}) => {
            dispatch({
                type: LOCATION_VERIFY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: LOCATION_VERIFY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function handleFilterChange(change, filter) {
    return function(dispatch){
        dispatch({type: HANDLE_FILTER_CHANGE})
        return (
            dispatch({
                type: HANDLE_FILTER_CHANGE,
                payload: [!change, filter]
            })
        )}
}

export function getOrdersStatusWeight(params){
    return function (dispatch){
        dispatch({type: GET_ORDERS_STATUS_WEIGHT})
        return adminServerInstance.get(`/map/getdriverorderbyweightandstatus`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_ORDERS_STATUS_WEIGHT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ORDERS_STATUS_WEIGHT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getDriverOrdersByShippingStatus(driverId){
    return function (dispatch){
        dispatch({type: GET_ORDERS_BY_SHIPPING_STATUS})
        return adminServerInstance.get(`/map/getdriverordersbyshipstatus?driver_id=${driverId}`)
        .then(({data}) => {
            dispatch({
                type: GET_ORDERS_BY_SHIPPING_STATUS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ORDERS_BY_SHIPPING_STATUS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function updateDispatchHistory(dispatchId, warehouse){
    return function (dispatch){
        dispatch({type: UPDATE_DISPATCH_HISTORY})
        return adminServerInstance.post('map/updatedispatchhistory', {
            id: dispatchId,
            warehouse: warehouse,
            is_removed: 1
        }).then(({data}) => {
            dispatch({
                type: UPDATE_DISPATCH_HISTORY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: UPDATE_DISPATCH_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getBatchNumber(area = 1, isHideAssociated = true, isHideSubRef = false, timestamp) {
    return function(dispatch) {
        dispatch({type: GET_BATCH})
        return adminServerInstance.get(`/map/getbatchlist`, {
                params: {
                    branch: area,
                    hide_associated: isHideAssociated ? 1: 0,
                    // hide_sub_referrer: isHideSubRef ? 1: 0
                    hide_sub_referrer: 0,
                    start_time: timestamp
                }
            }).then(({data}) => {
                dispatch({
                    type: GET_BATCH_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getStaffList(area = 1, isHired = 0) {
    return function(dispatch) {
        dispatch({type: GET_STAFF_LIST})
        return adminServerInstance.get('/map/getalldrivers', {
                params: {
                    branch: area,
                    is_hired: isHired,
                    page: 1,
                    size: 100000
                }
            }).then(({data}) => {
                dispatch({
                    type: GET_STAFF_LIST_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_STAFF_LIST_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getBatchOrderArea(batches, isHideAssociated = true, isHideSubRef = false) {
    return function(dispatch){
        dispatch({type: GET_BATCH_ORDER})
        return adminServerInstance.get(`/map/getbatchorders`, {
            params: {
                batch_list: batches.toString(),
                hide_associated: isHideAssociated ? 1:0,
                // hide_sub_referrer: isHideSubRef ? 1: 0
                hide_sub_referrer: 0
            }
            }).then(({data}) => {
                dispatch({
                    type: GET_BATCH_ORDER_SUCCESS,
                    payload: data
                })
            }).catch(error => {
                dispatch({
                    type: GET_BATCH_ORDER_FAIL,
                    payload: error
                })
            })
    }
}

export function createSubBatch(batches) {
    return function(dispatch){
        dispatch({type: CREATE_SUB_BATCH})
        return adminServerInstance.post(`/cargo/createsubbatch`, {
                batch_list: batches.toString(),
                version: 1
            }).then(({data}) => {
                dispatch({
                    type: CREATE_SUB_BATCH_SUCCESS,
                    payload: data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: CREATE_SUB_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getDirections(waypoints = []){
    return function(dispatch){
        dispatch({type: GET_DIRECTION})
        return adminServerInstance.post(`/map/getdirections`, {
                waypoints: waypoints
            }).then(({data}) => {
                dispatch({
                    type: GET_DIRECTION_SUCCESS,
                    payload: data
                })
            }).catch(error => {
                dispatch({
                    type: GET_DIRECTION_FAIL,
                    payload: error
                })
            })
    }
}
export function getPartnerList(){
    return function(dispatch){
        dispatch({type: GET_PARTNERS})
        return adminServerInstance.get(`/business/getpartners`)
            .then(({data}) => {
                dispatch({
                    type: GET_PARTNERS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_PARTNERS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getZipcodePatterns(warehouse) {
    return function (dispatch) {
        dispatch({type: GET_ZIPCODE_PATTERN})
        return adminServerInstance.get(`/orders/getplanningpatterns`, {
            params:
                {
                    warehouse: warehouse
                }
        }).then(({data}) => {
            dispatch({
                type: GET_ZIPCODE_PATTERN_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ZIPCODE_PATTERN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getWarehousePatterns(warehouse) {
    return function (dispatch) {
        dispatch({type: GET_WAREHOUSE_PATTERN})
        return adminServerInstance.get(`/map/getwarehousepattern`, {
            params:
                {
                    warehouse: warehouse
                }
        }).then(({data}) => {
            dispatch({
                type: GET_WAREHOUSE_PATTERN_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_WAREHOUSE_PATTERN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function updateRoutePattern(batchType, batchNo, warehouse, pattern, routeNo, zipcodeLength, routeNoFilter) {
    return function (dispatch) {
        dispatch({type: UPDATE_ROUTE_PATTERN})
        return adminServerInstance.post(`/orders/replanningroutes`, {
            batch_type: batchType,
            batch_no: batchNo,
            pattern: pattern,
            warehouse: warehouse,
            route_no: routeNo,
            zipcode_len: zipcodeLength,
            routeNoFilter: routeNoFilter
        }).then(({data}) => {
            dispatch({
                type: UPDATE_ROUTE_PATTERN_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: UPDATE_ROUTE_PATTERN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getDistricts(){
    return function(dispatch){
        dispatch({type: GET_DISTRICT})
        return adminServerInstance.get(`/map/getdistricts`)
            .then(({data}) => {
                dispatch({
                    type: GET_DISTRICT_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_DISTRICT_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getExpirationProcessingType() {
    return function (dispatch) {
      dispatch({ type: GET_EXPIRATION_TYPE });
      return adminServerInstance.get(`/orders/getexpirationprocessingtype`)
        .then(({ data }) => {
          dispatch({
            type: GET_EXPIRATION_TYPE_SUCCESS,
            payload: data.data
          });
          return Promise.resolve(data.data);
        })
        .catch(error => {
          dispatch({
            type: GET_EXPIRATION_TYPE_FAIL,
            payload: error
          });
          return Promise.reject(error);
        });
    };
  }

  export function updateOrderExpirationProcessingType(params) {
    return function (dispatch) {
      dispatch({ type: UPDATE_EXPIRATION_TYPE });
      return adminServerInstance.post(`/orders/updateorderexpirationprocessingtype`, params)
        .then(({ data }) => {
          dispatch({
            type: UPDATE_EXPIRATION_TYPE_SUCCESS,
            payload: data
          });
          return Promise.resolve(data);
        })
        .catch(error => {
          dispatch({
            type: UPDATE_EXPIRATION_TYPE_FAIL,
            payload: error
          });
          return Promise.reject(error);
        });
    };
  }
  

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {array} params.orders - Order Id's
 * @param {string} params.to_driver - To driver id
 * @param {string} params.from_driver - From driver_id
 * @param {string} params.operator - Operator name
 * @param {string} params.planner_id - Planner id - optional
 * @param {string} params.batch_info - Batches - optional
 */
export function assignOrderToDriver(params){
    return function(dispatch){
        dispatch({type: ASSIGN_ORDER})
        return adminServerInstance.post(`/map/assignorderstodriver`, params)
        .then(({data})=> {
                dispatch({
                    type: ASSIGN_ORDER_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: ASSIGN_ORDER_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getDriverOrderCount(districtId = 1, batchIds=[], isHideAssociated=true, isHideSubRef = false){
    return function(dispatch){
        dispatch({type: GET_DRIVER_ORDER_COUNT})
        return adminServerInstance.get('/map/getdriverordercountmerged', {
            params: {
                branch: districtId,
                batch_list: batchIds.toString(),
                hide_associated: isHideAssociated ? 1:0,
                // hide_sub_referrer: isHideSubRef ? 1: 0
                hide_sub_referrer: 0
            }
            }).then(({data}) => {
                dispatch({
                    type: GET_DRIVER_ORDER_COUNT_SUCCESS,
                    payload: data.data
                })
            }).catch(error => {
                dispatch({
                    type: GET_DRIVER_ORDER_COUNT_FAIL,
                    payload: error
                })
            })
    }
}

export function getDriverOrders(driverId, batchIds=[], isHideAssociated=true, isHideSubRef=false, warehouseId){
    return function(dispatch){
        dispatch({type: GET_DRIVER_ORDERS})
        return adminServerInstance.get(`/map/getdriverordersinbatchlist`, {
                params: {
                    driver_id: driverId,
                    batch_list: batchIds.toString(),
                    hide_associated: isHideAssociated ? 1:0,
                    // hide_sub_referrer: isHideSubRef ? 1: 0
                    hide_sub_referrer: 0,
                    branch: warehouseId
                }
            }).then(({data}) => {
                dispatch({
                    type: GET_DRIVER_ORDERS_SUCCESS,
                    payload: {
                        data: data.data,
                        driverId: driverId
                    }
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_DRIVER_ORDERS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function getDispatchHistoryList(districtId){
    return function (dispatch){
        dispatch({type: GET_DISPATCH_HISTORY_LIST})
        return adminServerInstance.get('map/getdispatchlisthistory', {
            params: {
                branch: districtId,
                page: 1,
                offset: 10000
                //offset - how many items per page
            }
        }).then(({data}) => {
            dispatch({
                type: GET_DISPATCH_HISTORY_LIST_SUCCESS,
                payload: data.data
            })
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type: GET_DISPATCH_HISTORY_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function createDispatchHistory(districtId, owner, dispatchName, batchIds){
    return function(dispatch){
        dispatch({type: CREATE_DISPATCH_HISTORY})
        return adminServerInstance.post('map/createdispatchhistory', {
            branch: districtId,
            owner: owner,
            name: dispatchName,
            batch_list: batchIds.toString()
        }).then(({data}) => {
            dispatch({
                type: CREATE_DISPATCH_HISTORY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(true);
        }).catch(error => {
            dispatch({
                type: CREATE_DISPATCH_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getBatchInfo(districtId, batchIds, isHideAssociated = true, isHideSubRef = false){
    return function(dispatch){
        dispatch({type: GET_BATCH_INFO})
        return adminServerInstance.get('map/getordersnuminbatchlist', {
            params: {
                branch: districtId,
                batch_list: batchIds.toString(),
                hide_associated: isHideAssociated ? 1: 0,
                // hide_sub_referrer: isHideSubRef ? 1: 0
                hide_sub_referrer: 0
            }
        }).then(({data}) => {
            dispatch({
                type: GET_BATCH_INFO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type: GET_BATCH_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}


export function resetOrders(){
    return function(dispatch){
        dispatch({type: RESET_ORDERS})
        return Promise.resolve();
    }
}